import {gql, useMutation} from "@apollo/client";

const REMOVE_STAGE_PLAY_DAY_MUTATION = gql`
mutation RemoveStagePlayDay($stagePlayDayId: Int!) {
  removeStagePlayDay(stagePlayDayId: $stagePlayDayId) {
     success
  }
}
`;

export default function RemoveStagePlayDayMutation() {
    return useMutation(REMOVE_STAGE_PLAY_DAY_MUTATION);
}